import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Advertiser } from '../models/advertiser';



@Injectable({
  providedIn: 'root'
})
export class AdvertiserService {

  constructor(private httpClient: HttpClient) { }

  getAdvertiserByName(name: string): Observable<Advertiser> {
    const host = environment.host;
      return this.httpClient.get<Advertiser>(host + '/advertisers/getAdvertiserByName/' + name, {headers: {'http2':'true'}});
  }

  searchAdvertisers(searchKeyWords: string): Observable<Advertiser[]> {
    const host = environment.host;
   return this.httpClient.get<Advertiser[]>(host + '/advertisers/searchAdvertisers/' + searchKeyWords);
    }
}
